import type { IOrganizationPermissionPasswordPolicy } from './OrganizationPermissionPasswordPolicy.interface';

export default class OrganizationPermissionPasswordPolicy
  implements IOrganizationPermissionPasswordPolicy {
  length: number;
  expires: number;
  lowercase: boolean;
  uppercase: boolean;
  digits: boolean;
  symbols: boolean;

  static build = (data: IOrganizationPermissionPasswordPolicy) =>
    new OrganizationPermissionPasswordPolicy(data);
  static blank = () => new OrganizationPermissionPasswordPolicy();

  /**
   * Constructor
   * @param {IOrganizationPermissionPasswordPolicy} data
   */
  constructor(data?: IOrganizationPermissionPasswordPolicy) {
    this.length = parseInt(data?.length, 10) || 8;
    this.expires = parseInt(data?.expires, 10) || 0;
    this.lowercase = data?.lowercase !== false;
    this.uppercase = data?.uppercase !== false;
    this.digits = data?.digits !== false;
    this.symbols = data?.symbols !== false;
  }
}
